import { useSelector } from "react-redux";

const useSubTenants = () => {
  const subTenants = useSelector((state) => state.tenantReducer.subTenants);
  return subTenants;
};

export default useSubTenants;
